import type { ComplexItem, Complexes, GetComplexesParams } from 'app/common/types/food/schools/complexes'

import type { Request } from '../../../index'

type ParamsApi = {
  date?: string // при установке вернется список заполненных комплектов с составом на эту дату
  deleted?: boolean
  visible?: boolean
  include_subsidy_orders?: boolean // при установке вернется список заполненных комплектов со списком справок на льготное питание
}

type PathParams = {
  orgId: string
}

type DishItemApi = {
  id: number
  title: string
  photoUrl: string
  portion: string
  cost: string
  saleType: string
  index?: number
}

type ComplexItemApi = {
  id: number
  title: string
  fixed_price_enabled: boolean
  visible: boolean
  deletable: boolean
  cost?: number
  fixed_price?: number
  grocery_set_price: number | null
  fund_movement_type_code: number // код движения средств

  position: number //порядок сортировки
  buffet_zone: boolean // зона буфета
  hot_meals_zone: boolean // зона горячего питания
  deny_parent_money_sales: boolean // Не продавать за родительские средства
  deny_more_than_one_sales: boolean
  disable_for_terminal_guest_sales: boolean
  use_as_additional: boolean // Использовать как дополнительный комплект при создании справок с выбором “один из множества”

  subsidy_orders?: {
    [id: string]: { id: number }
  }
  items?: {
    [id: string]: DishItemApi
  }
  photo_url: string | null
  last_change?: ComplexItem['last_change']
}

type ResultApi = {
  [id: string]: ComplexItemApi
}

type UrlParams = {
  orgId: number | string
}

export const convertParams = (params: GetComplexesParams): [ParamsApi, PathParams] => [
  {
    date: params.date,
    deleted: params.deleted,
    visible: params.visible,
    include_subsidy_orders: params.includeSubsidyOrders,
  },
  { orgId: params.orgId },
]

export const convertResult = (apiData: ResultApi): Complexes =>
  Object.fromEntries(
    Object.entries(apiData).map(([key, item]) => [
      key,
      {
        id: item.id,
        title: item.title,
        fixed_price_enabled: item.fixed_price_enabled,
        visible: item.visible,
        deletable: item.deletable,
        cost: item.cost === undefined ? undefined : String(item.cost),
        fixed_price: item.fixed_price === undefined ? undefined : String(item.fixed_price),
        grocery_set_price: item.grocery_set_price === null ? null : String(item.grocery_set_price),
        fund_movement_type_code: item.fund_movement_type_code,
        position: item.position,
        buffet_zone: item.buffet_zone,
        hot_meals_zone: item.hot_meals_zone,
        deny_parent_money_sales: item.deny_parent_money_sales,
        deny_more_than_one_sales: item.deny_more_than_one_sales,
        disable_for_terminal_guest_sales: item.disable_for_terminal_guest_sales,
        use_as_additional: item.use_as_additional,
        subsidy_orders: item.subsidy_orders,
        items:
          item.items &&
          Object.fromEntries(
            Object.entries(item.items).map(([itemKey, dish]) => [
              itemKey,
              {
                ...dish,
                cost: Number(dish.cost),
                index: dish.index ?? 0,
              },
            ]),
          ),
        photo_url: item.photo_url,
        last_change: item.last_change,
      },
    ]),
  )

export const GET_COMPLEXES: Request<GetComplexesParams, Complexes, UrlParams> = [
  'food/schools/{orgId}/complexes',
  'get',
  ['data', 'complexes'],
]
